// import * as jwt from 'jsonwebtoken';

// /**
//  * scrambles string data
//  * @param {String} token - input string data
//  * @returns {String} - scrambled data
//  */
// const shuffleToken = token => token.split('').reverse().join('');

// const verifyToken = token => {
//   if (!token)
//     return {
//       Error: 'Failed to authenticate token',
//       success: false
//     };
//   const reshuffledToken = shuffleToken(token);
//   let output = {};
//   return jwt.verify(
//     reshuffledToken,
//     process.env.REACT_APP_JWT_SECRET,
//     (err, decoded) => {
//       if (err) {
//         output = {
//           Error: 'Failed to authenticate token',
//           success: false
//         };
//       } else {
//         output = { success: true, ...decoded };
//       }
//       return output;
//     }
//   );
// };

// export { verifyToken, shuffleToken };

import { decodeJWT } from './utilities/decodeJWT';

const shuffleToken = token => token.split('').reverse().join('');

const verifyToken = token => {
  const reshuffledToken = token ? shuffleToken(token) : null;

  const decoded = decodeJWT(reshuffledToken);

  if (!decoded || !decoded.payload) {
    return { success: false, error: 'Failed to authenticate token' };
  }

  const currentTime = Math.floor(Date.now() / 1000);

  const tokenExpiry = decoded.payload.exp;

  if (tokenExpiry < currentTime) {
    return { success: false, error: 'Token has expired' };
  }

  return { success: true, ...decoded.payload };

  // return decoded
  //   ? { success: true, ...decoded.payload }
  //   : { success: false, error: 'Failed to authenticate token' };
};

export { verifyToken, shuffleToken };
